<template>
  <v-card v-if="task">
    <v-toolbar dark :color="task.closedAt ? 'jeff-life' : 'navy'">
      <span class="text-h6 font-weight-bold">{{ task.title }}</span>
      <template v-if="task.taskType.title != 'Support'">
        <v-spacer />
        <template v-if="task.closedAt"> Completed: {{ task.closedAt | moment("ddd D MMM YYYY") }} </template>
        <v-btn v-else outlined color="white" small @click="updateTask(completedState, task.id, 'stageId')">
          <v-icon>mdi-check</v-icon>
        </v-btn>
      </template>
    </v-toolbar>
    <v-card-text>
      <v-row>
        <v-col cols="12" class="pt-0">
          <span class="title block black--text text-body-1" v-html="task.description" />
          <v-expansion-panels class="mt-5">
            <v-expansion-panel>
              <v-expansion-panel-header>
                Assign / Snooze
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card elevation="0" class="ma-0 pa-0">
                  <div v-if="task.reporter" class="d-flex justify-space-between">
                    <div class="mb-4">
                      Reporter:
                      <span> {{ task.reporter.firstName }} {{ task.reporter.lastName }} </span>
                    </div>
                  </div>
                  <div>
                    <div v-if="!updateAssignee" class="d-flex justify-space-between">
                      <div class="mb-4">
                        Assigned To:
                        <span v-if="task.assignedTo">
                          {{ task.assignedTo.firstName }} {{ task.assignedTo.lastName }}
                        </span>
                        <span v-else>
                          Not set
                        </span>
                      </div>
                      <v-icon @click="editAssignee()">mdi-account-edit-outline</v-icon>
                    </div>
                    <div v-else class="d-flex  justify-space-between mt-2">
                      <v-autocomplete
                        v-if="staff"
                        class="ml-2 pt-1"
                        :value="assignedTo"
                        item-text="name"
                        item-value="id"
                        dense
                        filled
                        outlined
                        small-chips
                        solo
                        rounded
                        :disabled="task.closedAt ? true : false"
                        :items="staff"
                        @change="updateTask($event, task.id, 'assignedTo')"
                      >
                        <template v-slot:selection="data">
                          <v-chip v-bind="data.attrs" :input-value="data.selected">
                            <v-avatar left>
                              <v-img :src="data.item.avatar"></v-img>
                            </v-avatar>
                            {{ data.item.name }}
                          </v-chip>
                        </template>
                        <template v-slot:item="data">
                          <v-list-item-avatar>
                            <img :src="data.item.avatar" />
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title v-html="data.item.name"></v-list-item-title>
                          </v-list-item-content>
                        </template>
                      </v-autocomplete>
                      <v-btn icon small class="mx-2 mt-2" elevation="2" @click="cancelEdit()">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </div>
                  </div>
                  <div>
                    <template v-if="task.taskType.title == 'Support'">
                      <template v-if="task.closedAt">
                        Completed at: {{ task.closedAt | moment("YYYY-MM-DD HH:MM") }}
                      </template>
                      <span class="mr-2 pt-2 block">Stage:</span>
                      <v-select
                        v-if="stages"
                        :value="task.stage.id"
                        :items="stages"
                        label="Solo field"
                        single-line
                        dense
                        outlined
                        rounded
                        class="mt-2"
                        @change="updateTask($event, task.id, 'stageId')"
                      ></v-select>
                    </template>
                  </div>
                  <div>
                    <v-menu ref="menu1" v-model="menu1" transition="scale-transition">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="snoozeUntil"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          prepend-inner-icon="mdi-calendar"
                          clearable
                          outlined
                          rounded
                          :disabled="task.closedAt ? true : false"
                          dense
                          label="Choose a snooze date"
                        />
                      </template>
                      <v-date-picker v-model="snoozeUntil" width="350px" />
                    </v-menu>
                  </div>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <div class="mt-2">
            <task-attachment :taskId="task.id" :attachments="attachments" />
          </div>

          <v-row v-if="task.taskType.tasktypesuggestionSet.length > 0" class="pt-0 mt-0">
            <v-col cols="12">
              <v-expansion-panels>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    Copy Message Suggestions
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card elevation="0" class="ma-0 pa-0 overflow-auto">
                      <span
                        v-for="suggestion in task.taskType.tasktypesuggestionSet"
                        :key="suggestion.id"
                        class="block py-2 suggestion fake-link"
                        @click="copyText(suggestion.message)"
                      >
                        {{ suggestion.message }}
                      </span>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row>
          <task-comment :taskId="task.id" />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { STAGES_QUERY } from "@/graphql/queries/task";
import { UPSERT_TASK_EVENT_MUTATION } from "@/graphql/mutations/task";
import { STAFF_QUERY } from "@/graphql/queries/user";
import { decodeId } from "@/lib/string";
import { getUserName } from "@/lib/username";
import TaskComment from "@/components/task/components/TaskComment";
import TaskAttachment from "@/components/task/components/TaskAttachment";

export default {
  name: "UserTasks",
  components: {
    TaskComment,
    TaskAttachment,
  },
  props: {
    task: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      staff: [],
      menu1: false,
      stages: null,
      showModal: null,
      hasCoachingChat: false,
      snoozeUntil: this.task.snoozeUntil,
      updateAssignee: false,
    };
  },
  watch: {
    task: function() {
      this.updateAssignee = false;
    },
    snoozeUntil: function(value) {
      this.updateTask(value, this.task.id, "snoozeUntil");
    },
  },
  computed: {
    completedState() {
      return this.stages.filter((stage) => stage.text == "Completed")[0].value;
    },
    assignedTo() {
      return this.task.assignedTo?.id;
    },
    attachments() {
      return this.task.taskeventattachmentSet;
    },
  },
  methods: {
    async copyText(text) {
      await navigator.clipboard.writeText(text);
      this.$toasted.success("Copied", {
        duration: 2000,
        position: "bottom-center",
      });
    },
    editAssignee() {
      this.updateAssignee = true;
    },
    cancelEdit() {
      this.updateAssignee = false;
    },
    updateTask(event, taskId, variable) {
      if (event == null && variable == "assignedTo") {
        return;
      }
      var data = {};
      data[variable] = event;

      this.$apollo
        .mutate({
          mutation: UPSERT_TASK_EVENT_MUTATION,
          variables: {
            taskEventId: decodeId(taskId),
            data: data,
          },
          refetchQueries: ["taskEventsQuery", "myUsersQuery"],
        })
        .then((result) => {
          if (!result.data.upsertTaskEvent.updated) {
            alert(result.data.upsertTaskEvent.error);
          } else {
            this.$toasted.success("Task Updated", {
              icon: "arm-flex",
              duration: 2000,
              position: "bottom-center",
            });
          }
        });
    },
  },
  apollo: {
    users: {
      query: STAFF_QUERY,
      variables() {
        return {
          isActive: true,
          isStaff: true,
        };
      },
      fetchPolicy: "cache-and-network",
      result(response) {
        if (response.data && !response.loading) {
          this.staff = [];

          response.data.users.edges.forEach((item) => {
            let data = {
              id: decodeId(item.node.id),
              name: getUserName(item.node),
              avatar: item.node.userProfile?.profilePicture,
            };

            this.staff.push(data);
          });

          this.staff.sort((a, b) => (a.text > b.text ? 1 : -1));
        }
      },
    },
    stages: {
      query: STAGES_QUERY,
      fetchPolicy: "cache-and-network",
      update(data) {
        return data.stages.map((item) => {
          return {
            text: item.title,
            value: item.id,
          };
        });
      },
    },
  },
};
</script>

<style scoped>
.suggestion {
  border-bottom: 1px solid black;
}
</style>
